import MMCompanyStore from "./MMCompanyStore";
import MMProjectStore from "./MMProjectStore";
import MMProductionStore from "./MMProductionStore";
import MMLoadStore from "./MMLoadStore";
import MMDailyReportStore from "./MMDailyReportStore";

// Export individual stores for direct imports
export {
  MMCompanyStore,
  MMProjectStore,
  MMProductionStore,
  MMLoadStore,
  MMDailyReportStore,
};

// Export types
export * from "./MMCompanyStore";
export * from "./MMProjectStore";
export * from "./MMProductionStore";
export * from "./MMLoadStore";
export * from "./MMDailyReportStore";

// Store list for appStoresConfig
const millerMizeStoreList = [
  { name: "mmCompanyStore", store: MMCompanyStore },
  { name: "mmProjectStore", store: MMProjectStore },
  { name: "mmProductionStore", store: MMProductionStore },
  { name: "mmLoadStore", store: MMLoadStore },
  { name: "mmDailyReportStore", store: MMDailyReportStore },
];

export default millerMizeStoreList;
